import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
} from 'actionTypes';

import { BLOGGERS } from 'constants/bloggers';

export const fetchBlogs = () => async dispatch => {
  dispatch({
    type: FETCH_BLOGS_REQUEST,
    payload: {},
  });

  try {
    const responseData = await Promise.all(
      Object.keys(BLOGGERS).map(item =>
        fetch(
          `${process.env.APP_BLOGS_API_ROOT}/${item}/?cpp=1&page=1`
        ).then(response => response.json())
      )
    );

    const sortedData = responseData
      .sort((a, b) => {
        return new Date(b.data[0].date) - new Date(a.data[0].date);
      })
      .slice(0, 3);

    const result = sortedData.reduce((obj, item) => {
      const data = item.data[0];
      const bloggerName = data.link.split('/')[2];

      // eslint-disable-next-line no-param-reassign
      obj[bloggerName] = data;
      return obj;
    }, {});

    return dispatch({
      type: FETCH_BLOGS_SUCCESS,
      payload: {
        items: result,
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_BLOGS_FAILURE,
      payload: {},
    });
  }
};

export default fetchBlogs;
